import { render, staticRenderFns } from "./header-search.vue?vue&type=template&id=6f1afa71&scoped=true"
import script from "./header-search.vue?vue&type=script&lang=js"
export * from "./header-search.vue?vue&type=script&lang=js"
import style0 from "./header-search.vue?vue&type=style&index=0&id=6f1afa71&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1afa71",
  null
  
)

export default component.exports